import layout from 'layouts/default'
import { dateFormat } from 'filters'
import { confirm } from 'components/modals'
import parkingRateModal from '../parkingRateModal'
import roomRateModal from '../roomRateModal'
import bundleRateModal from '../bundleRateModal'
import bulkUpload from '../bulkUpload'
import rateViews from '../rateViews'
import tabs from '../tabs'
import { fetchLocationAndRedirectTps } from 'utils/tpsIntegration'
import { hasPermits } from 'directives'


const directives = {
  hasPermits
}

const components = {
  layout,
  parkingRateModal,
  roomRateModal,
  bundleRateModal,
  confirm,
  bulkUpload,
  rateViews,
  tabs
}

const filters = {
  dateFormat
}

const computed = {
  location () {
    return _.cloneDeep(this.$store.state.locations.active);
  },
  channel() {
    return _.cloneDeep(this.$store.state.locations.activeChannel.channel);
  }
}

const methods = {
  refreshRates () {
    this.$refs.rateReviews.getRates();
  }
}


export default {
  name: 'rates-tab',
  components,
  computed,
  methods,
  filters,
  directives,
  data () {
    return {
      loading: false,
      locId: this.$route.params.id
    }
  },
  created () {
    const id = this.$route.params.id
    this.loading = true
    fetchLocationAndRedirectTps(this.$store, this.$router, id).then((shouldShowRates) => {
      if (!shouldShowRates) {
        return
      }
      return Promise.all([
        this.$store.dispatch('locations.getChannels', id),
        this.$store.dispatch('locations.parkingTypes', {id}),
        this.$store.dispatch('locations.roomTypes', {id}),
        this.$store.dispatch('locations.bundleTypes', {id}),
      ])
    }).then((loaded) => {
      if (loaded) {
        this.loading = false
      }
    })
  }
}
